/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Button, InfoTooltip } from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import AccountIcon from './Icons/AccountIcon';
import UnoFormatIcon from './Icons/UnoFormatIcon';

const base64Decode = (token) => {
  const e = {}; let i; let b = 0; let c; let x; let l = 0; let a; let r = ''; const w = String.fromCharCode; const
    L = token.length;
  const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (i = 0; i < 64; i++) { e[A.charAt(i)] = i; }
  for (x = 0; x < L; x++) {
    c = e[token.charAt(x)]; b = (b << 6) + c; l += 6;
    while (l >= 8) { ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a)); }
  }
  return r;
};

const getParams = (query) => {
  const indexOfQM = query.indexOf('?');
  if (indexOfQM > 0) {
    query = query.substring(indexOfQM);
  }
  if (!query) {
    return {};
  }
  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
};

const isCustomized = ({ client = '' }) => {
  client = client.toLowerCase();
  switch (client) {
    case 'AEB8952C-EF6B-4AAB-980C-FF9F9BA0DAE8'.toLowerCase():
    case '6A1AE8DD-81BF-4559-B38E-9010A8D0FA2B'.toLowerCase():
    case 'AC52E09A-0421-453B-BDFC-2FAFE7590339'.toLowerCase():
      return {
        client,
        appplication: 'UnoFormat',
        style: 'unoFormat',
        background: 'url("https://www.unoformat.it/img/bg_login.jpg?v=1")',
        logo: <UnoFormatIcon />,
        linkContatti: window.linkContattiUnoFormat,
        informazioniAddizionaliLogin: (
          <InfoTooltip right>
            <div className="unoformat__infoTitle">
              <strong>
                Quali credenziali utilizzare per accedere
                <br /> al nuovo sito Unoformat?
              </strong>
            </div>
            <ul className="unoformat__listaInfo">
              <li className="unoformat__listaInfoItem">
                <div>
                  <SuccessoIcon />
                </div>
                <span>Se sei un nuovo utente clicca su REGISTRATI
                  <br /> e segui la procedura di registrazione
                </span>
              </li>
              <li className="unoformat__listaInfoItem">
                <div>
                  <SuccessoIcon />
                </div>
                <span>Se sei già in possesso delle credenziali Unoformat,
                  <br /> al posto del nome utente dovrai utilizzare il tuo codice fiscale
                  <br /> e come password quella di accesso ad Unoformat
                </span>
              </li>
              <li className="unoformat__listaInfoItem">
                <div>
                  <SuccessoIcon />
                </div>
                <span>Se sei un utente già registrato su Unoformat
                  <br /> e anche un Associato CGN, dovrai utilizzare le credenziali
                  <br /> di accesso di CGN (codice fiscale e password)
                </span>
              </li>
            </ul>
          </InfoTooltip>),
        registrati: (
          <Button className="effettuaLogin__button" onClick={() => { window.location.href = window.urlRegistrazioneUnoFormat; }}>
            Registrati
          </Button>),
      };

    default:
      return {
        client,
        appplication: 'Default',
        style: 'default',
        background: 'url("/Content/background.jpg?v=1")',
        logo: <AccountIcon />,
        linkContatti: 'http://www.cgn.it/contatti-e-responsabili-regionali-relazioni',
        registratiTop: <div><span>Utilizza il tuo account CGN per continuare</span><br /><br /></div>,
      };
  }
};

const addParamToUrl = (url, param) => url + (url.indexOf('?') > 0 ? '&' : '?') + param;

export {
  base64Decode, getParams, isCustomized, addParamToUrl,
};
